<template>
  <div>
    <h1>이곳은 Hira 페이지입니다.</h1>
  </div>
</template>

<script>
export default {
  name: "Hira",
};
</script>

<style scoped>
/* Add your page-specific styles here */
</style>
